import { createContext, useContext, useLayoutEffect, useMemo, useState } from 'react'
import {
  applyViewPreferenceAttributes,
  normalizeViewPreferences,
  readViewPreferences,
  writeViewPreferences,
} from './viewPreferencesStore'

const ViewPreferencesContext = createContext(null)

export function ViewPreferencesProvider({ children }) {
  const [preferences, setPreferences] = useState(readViewPreferences)

  useLayoutEffect(() => {
    const normalized = normalizeViewPreferences(preferences)
    applyViewPreferenceAttributes(normalized)
    writeViewPreferences(normalized)
  }, [preferences])

  const value = useMemo(() => ({
    preferences,
    setViewPreference(key, nextValue) {
      setPreferences((current) => normalizeViewPreferences({ ...current, [key]: nextValue }))
    },
  }), [preferences])

  return <ViewPreferencesContext.Provider value={value}>{children}</ViewPreferencesContext.Provider>
}

export function useViewPreferences() {
  const context = useContext(ViewPreferencesContext)
  if (!context) throw new Error('useViewPreferences must be used inside ViewPreferencesProvider')
  return context
}
